import React from 'react';
import {connect} from 'react-redux';
import Container from '../../components/templates/Login/resetPassword';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

/**
 * ログイン画面:パスワードリセット(認証コード発行) ページ。
 * 画面ID:3000
 */
class App extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0);
  }

  /**
   * 画面描画。
   *
   * @return {JSX.Element} 描画要素
   */
  render() {
    return (<Container
      {...this.props}
    />);
  }
}

const ContainerApp = connect(
    mapStateToProps,
    mapDispatchToProps,
)(App);

App.propTypes = {
};

export default ContainerApp;
